import React, { useState } from 'react'
import { message, Modal } from "antd";

import Header from './Header'

const AntiqueSection = ({ SectionData, UpdateImage, UpdateText }) => {
    const [HeadingUpdate, setHeadingUpdate] = useState('')
    const [TextModalVisible, setTextModalVisible] = useState(false);
    const [UpdateId, setUpdateId] = useState('')

    const handleCancel = () => {
        setTextModalVisible(false);
    };

    const ShowTextModal = (id) => {
        setTextModalVisible(true);
        setUpdateId(id)
    };


    const TextHandle = () => {
        if (HeadingUpdate === '') {
            message.error('Fill the Field')
        } else {
            UpdateText({
                text: HeadingUpdate,
                id: UpdateId
            })
            setTextModalVisible(false);
            setHeadingUpdate('')
        }
    };


    const OnEnterPress = (event) => {
        const a = HeadingUpdate
        console.log(a)
        if (event.key === 'Enter') {
            console.log('Enter Clicked')
            a.concat('\n')
            setHeadingUpdate(a)
        } else {
            console.log(event.key)
        }
    }


    return (
        <div className='Antique-Container'>
            <div className='Info'>
                <h2> {SectionData ? SectionData.section3heading1.content : 'No Text'}
                    <i onKeyPress={(e)=> OnEnterPress(e)} onClick={() => ShowTextModal(SectionData.section3heading1._id)} className="far fa-edit Edit-btn"></i>
                </h2>
                <div className='Antique-list'>
                    <p> {SectionData ? SectionData.section3paragraph1.content : 'No Text'}
                        <i onKeyPress={(e)=> OnEnterPress(e)} onClick={() => ShowTextModal(SectionData.section3paragraph1._id)} className="far fa-edit Edit-btn"></i>
                    </p>
                </div>
            </div>
            {SectionData && <div className='Images'>
                <Header
                    UpdateText={UpdateText}
                    UpdateImage={UpdateImage}
                    GetData={{
                        imgId: SectionData.section3image1._id,
                        headingId: SectionData.section3heading2._id
                    }}
                    Image={SectionData.section3image1.image}
                    Heading={SectionData.section3heading2.content} />

                <Header
                    UpdateText={UpdateText}
                    UpdateImage={UpdateImage}
                    GetData={{
                        imgId: SectionData.section3image2._id,
                        headingId: SectionData.section3heading3._id
                    }}
                    Image={SectionData.section3image2.image}
                    Heading={SectionData.section3heading3.content} />

                <Header
                    UpdateText={UpdateText}
                    UpdateImage={UpdateImage}
                    GetData={{
                        imgId: SectionData.section3image3._id,
                        headingId: SectionData.section3heading4._id
                    }}
                    Image={SectionData.section3image3.image}
                    Heading={SectionData.section3heading4.content} />

                <Header
                    UpdateText={UpdateText}
                    UpdateImage={UpdateImage}
                    GetData={{
                        imgId: SectionData.section3image4._id,
                        headingId: SectionData.section3heading5._id
                    }}
                    Image={SectionData.section3image4.image}
                    Heading={SectionData.section3heading5.content} />
            </div>}

            {/* Update Text Modal */}
            <Modal width={400} style={{ top: '20%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
                <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
            </Modal>

        </div>
    )
}

export default AntiqueSection
